export default __webpack_public_path__ + "static/media/oralcare.cdc8e0e2.jpg";